import { createApp } from '@/lib/createApp';
import CollectionFilters from '@/CollectionFilters.vue';
import CollectionProducts from '@/CollectionProducts.vue';
import CollectionSort from '@/CollectionSort.vue';
import CollectionGridSize from '@/components/CollectionGridSize.vue';
import CollectionFilterButtons from '@/CollectionFilterButtons.vue';
import FsSearchField from '@/components/FsSearchField.vue';
import ProductBadgePDP from '@/ProductBadgePDP.vue';
import ColorVariantOption from '@/ColorVariantOption.vue';
import SizeVariantOption from '@/SizeVariantOption.vue';
import WidthVariantOption from '@/WidthVariantOption.vue';
import PDPaddToCart from '@/PDPaddToCart.vue';
import PDPaddToCartSticky from '@/PDPaddToCartSticky.vue';
import PDPinventory from '@/PDPinventory.vue';
import PDPPriceBlock from '@/PDPPriceBlock.vue';
import LiveSearch from '@/LiveSearch.vue';
import EndlessScroll from '@/EndlessScroll.vue';
import CollectionSeeMore from '@/CollectionSeeMore.vue';
import ProductRecommendations from '@/ProductRecommendations.vue';
// import CartRecommendations from '@/CartRecommendations.vue';
import PDPImages from '@/PDPImages.vue';
import mitt from 'mitt';
import CompleteTheLook from '@/CompleteTheLook.vue';
import PDPZoom from '@/PDPZoom.vue';
import PDPYotpoUGC from '@/PDPYotpoUGC.vue';
import PDPSectionDoubleRefresh from '@/PDPSectionDoubleRefresh.vue';
import ProductGridItemBadges from '@/ProductGridItemBadges.vue';
import CollectionSlider from '@/CollectionSlider.vue';
import CollectionSplitGrid from '@/CollectionSplitGrid.vue';
import ProductTileGroup from '@/ProductTileGroup.vue';
import ProductFamilyHelper from '@/components/ProductFamilyHelper.vue';
import PDPSetReminderDisplayLogic from '@/PDPSetReminderDisplayLogic.vue';
import ProductUpsellOptions from '@/components/ProductUpsellOptions.vue';
import OutfitPicker from '@/OutfitPicker.vue';
import CartWidget from '@/CartWidget.vue';
import { initPlytixDataLoader } from '@/lib/plytixDataLoader.js';
import { attachCustomerAccountCookieOAuthToWindow } from '@/lib/customerAccountCookieOAuth.js';
import ProductComparison from '@/ProductComparison.vue';
import { bootstrap as bootstrapCustomerAuth, isConfiguredValue } from '@/lib/customerAuth';
import { fetchFirstCompanyLocationId } from '@/lib/customerAccount';
import { setBuyer, markBuyerSettled } from '@/lib/buyerContext';
import AdaValidator from '@/AdaValidator.vue';
export const emitter = mitt();

(async () => {
  const cap = window.customerAccount;
  const authConfigured = isConfiguredValue(cap?.clientId) && isConfiguredValue(cap?.tokenEndpoint) && isConfiguredValue(cap?.authorizationEndpoint);
  const authEnabled = window.customerAccountEnabled && window.isLoggedIn && authConfigured;
  if (!authEnabled) {
    markBuyerSettled();
    return;
  }
  try {
    const token = await bootstrapCustomerAuth();
    if (!token) {
      markBuyerSettled();
      return;
    }
    if (!window.b2bContextEnabled || !window.isB2B) {
      markBuyerSettled();
      return;
    }
    let companyLocationId = cap.companyLocationId || null;
    if (!companyLocationId) {
      companyLocationId = await fetchFirstCompanyLocationId();
    }
    setBuyer({
      customerAccessToken: token.access_token,
      ...(companyLocationId ? { companyLocationId } : {})
    });
  } catch (err) {
    void err;
    markBuyerSettled();
  }
})();

if (window.setClientWidthClass && !window.siteGlobals?.device) window.setClientWidthClass();

document.addEventListener('kameleoon:sdk:ready', event => {
  console.log('Vue heard kameleoon:sdk:ready event.', event.detail || {});
});

if (document.getElementById('product-upsell-options')) {
  createApp(ProductUpsellOptions).mount('#product-upsell-options');
}

[...document.querySelectorAll('.pdp-section-refresh')].forEach(pdpSectionDoubleRefresh => {
  let appId = pdpSectionDoubleRefresh.getAttribute('id');
  createApp(PDPSectionDoubleRefresh).mount(`#${appId}`);
});

if (document.getElementById('PDPSetReminderDisplayLogic')) {
  createApp(PDPSetReminderDisplayLogic).mount('#PDPSetReminderDisplayLogic');
}

document.querySelectorAll('[id^="OpSetReminderDisplayLogic"]').forEach(el => {
  if (!el.__vue_app__) createApp(PDPSetReminderDisplayLogic).mount(`#${el.id}`);
});

if (document.getElementById('ProductFamilyHelper')) {
  createApp(ProductFamilyHelper).mount('#ProductFamilyHelper');
}

if (document.getElementById('HelpGuideSize')) {
  createApp(ProductFamilyHelper).mount('#HelpGuideSize');
}

if (document.getElementById('sticky-PDPaddtocart')) {
  createApp(PDPaddToCartSticky).mount('#sticky-PDPaddtocart');
}

if (document.getElementById('PDPYotpoUGC')) {
  createApp(PDPYotpoUGC).mount('#PDPYotpoUGC');
}

if (document.getElementById('vue-zoom')) {
  createApp(PDPZoom).mount('#vue-zoom');
}

emitter.on('variant-color-selected', e => {
  const link = document.querySelector('.product__compare-plp-link');
  if (!link || !e.pid) return;
  const baseUrl = link.dataset.compareCollectionUrl;
  if (!baseUrl) return;
  const url = new URL(baseUrl, window.location.origin);
  url.searchParams.set('compare_pid', e.pid);
  if (e.color) url.searchParams.set('compare_color', e.color);
  link.href = url.toString();
});

emitter.on('start-full-pdp', e => {
  const pdpImagesEl = document.getElementById('PDPImages');
  if (pdpImagesEl) {
    pdpImagesEl.style.minHeight = pdpImagesEl.offsetHeight + 'px';
    const Props = { images: e.images, media: e.media, pid: e.pid };
    createApp(PDPImages, Props).mount('#PDPImages');
  }

  if (document.getElementById('CompleteTheLook')) {
    const Props = { handle: e.handle, tags: e.tags, pid: e.pid };
    createApp(CompleteTheLook, Props).mount('#CompleteTheLook');
  }

  if (document.getElementById('pdp-recommendations')) {
    const Props = { pid: e.pid };
    createApp(ProductRecommendations, Props).mount('#pdp-recommendations');
  }

  emitter.off('start-full-pdp');
});

if (document.getElementById('cart-recommendations')) {
  createApp(CartWidget).mount('#cart-recommendations');
}

if (document.getElementById('live-search-fs')) {
  createApp(LiveSearch).mount('#live-search-fs');
}

if (document.getElementById('live-search-fs-mobile')) {
  createApp(LiveSearch).mount('#live-search-fs-mobile');
}

/* --- Kameleoon See More PLP experiment: remove when experiment ends --- */
// KAM A/B mount signal: add `kam-plp-see-more` or `kam-plp-endless-scroll` on <html>
// before gm.js runs (not the div hooks in collection-fs.liquid — those are CSS-only). Or set
// window.theme.kameleoonSeeMorePlpEnabled via Kameleoon variation JS before gm.js runs.
// When removing: restore collection-fs.liquid to only render #fs-collection-endlessScroll (no see-more div),
// then replace this block with the original guard below:
//   if (document.getElementById('fs-collection-endlessScroll')) {
//     const endlessScrollEl = document.getElementById('fs-collection-endlessScroll');
//     const triggerDistance = endlessScrollEl.getAttribute('data-trigger-distance');
//     const loadingImage = endlessScrollEl.getAttribute('data-loading-image');
//     createApp(EndlessScroll, { triggerDistance: triggerDistance ? parseInt(triggerDistance) : 500, loadingImage: loadingImage || null }).mount('#fs-collection-endlessScroll');
//   }
(function mountPlpScrollComponent() {
  const seeMoreEl = document.getElementById('fs-collection-see-more');
  const endlessScrollEl = document.getElementById('fs-collection-endlessScroll');
  if (!seeMoreEl && !endlessScrollEl) return;

  function resolveUseSeeMore() {
    const root = document.documentElement;
    if (root.classList.contains('kam-plp-see-more')) return true;
    if (root.classList.contains('kam-plp-endless-scroll')) return false;
    const kamJsOverride = window.theme?.kameleoonSeeMorePlpEnabled;
    if (kamJsOverride !== undefined) return kamJsOverride;
    return seeMoreEl?.getAttribute('data-default-enabled') === 'true';
  }

  const useSeeMore = resolveUseSeeMore();

  if (useSeeMore && seeMoreEl) {
    createApp(CollectionSeeMore).mount('#fs-collection-see-more');
  } else if (!useSeeMore && endlessScrollEl) {
    const triggerDistance = endlessScrollEl.getAttribute('data-trigger-distance');
    const loadingImage = endlessScrollEl.getAttribute('data-loading-image');
    createApp(EndlessScroll, { triggerDistance: triggerDistance ? parseInt(triggerDistance) : 500, loadingImage: loadingImage || null }).mount('#fs-collection-endlessScroll');
  }
})();
/* --- end Kameleoon See More PLP experiment --- */

// if (document.getElementById('fs-collection-see-more')) {
//   createApp(CollectionSeeMore).mount('#fs-collection-see-more');
// }

if (document.getElementById('fs-collection-filters')) {
  createApp(CollectionFilters).mount('#fs-collection-filters');
}

if (document.getElementById('fs-search-field')) {
  createApp(FsSearchField).mount('#fs-search-field');
}

if (document.getElementById('fs-collection-filter-buttons')) {
  createApp(CollectionFilterButtons).mount('#fs-collection-filter-buttons');
}

[...document.querySelectorAll('.pdp-badge-router')].forEach(badgeApp => {
  let appId = badgeApp.getAttribute('id');
  createApp(ProductBadgePDP).mount(`#${appId}`);
});

const isPdp = document.body.classList.contains('template-product');

function initializeBadges() {
  const $prouctGridBadgeElements = document.querySelectorAll('.product-item-badge-router');

  [...$prouctGridBadgeElements].forEach(badgeApp => {
    const appId = badgeApp.getAttribute('id');
    createApp(ProductGridItemBadges).mount(`#${appId}`);
  });
}

if (isPdp) {
  window.addEventListener('theme:recent-products:added', () => {
    initializeBadges();
  });
} else {
  initializeBadges();
}

if (document.getElementById('fs-collection-products')) {
  createApp(CollectionProducts).mount('#fs-collection-products');
}

if (document.getElementById('fs-collection-sorting')) {
  createApp(CollectionSort).mount('#fs-collection-sorting');
}

if (document.getElementById('collection-grid-size')) {
  createApp(CollectionGridSize).mount('#collection-grid-size');
}

initPlytixDataLoader(emitter);

[...document.querySelectorAll('.color-variant-options')].forEach(colorVariantOption => {
  let colorId = colorVariantOption.getAttribute('id');
  createApp(ColorVariantOption).mount(`#${colorId}`);
});

[...document.querySelectorAll('.size-variant-options')].forEach(sizeVariantOption => {
  let sizeId = sizeVariantOption.getAttribute('id');
  createApp(SizeVariantOption).mount(`#${sizeId}`);
});

[...document.querySelectorAll('.width-variant-options')].forEach(widthVariantOption => {
  let widthId = widthVariantOption.getAttribute('id');
  createApp(WidthVariantOption).mount(`#${widthId}`);
});

if (document.getElementById('OutfitPicker')) {
  createApp(OutfitPicker).mount('#OutfitPicker');
}

function mountPDPaddToCart(el) {
  if (el.__vue_app__) return;
  createApp(PDPaddToCart).mount(el);
}

[...document.querySelectorAll('.PDPaddToCart')].forEach(mountPDPaddToCart);

document.addEventListener('theme:quickview:loaded', () => {
  document.querySelectorAll('.PDPaddToCart').forEach(mountPDPaddToCart);
  const qvReminder = document.getElementById('QuickviewSetReminderDisplayLogic');
  if (qvReminder && !qvReminder.__vue_app__) {
    createApp(PDPSetReminderDisplayLogic).mount('#QuickviewSetReminderDisplayLogic');
  }
});

[...document.querySelectorAll('.PDPinventory')].forEach(inventory => {
  let inventoryId = inventory.getAttribute('id');
  createApp(PDPinventory).mount(`#${inventoryId}`);
});

[...document.querySelectorAll('.PDPPriceBlock')].forEach(priceBlock => {
  let priceBlockId = priceBlock.getAttribute('id');
  createApp(PDPPriceBlock).mount(`#${priceBlockId}`);
});

[...document.querySelectorAll('.fs-collection-slider')].forEach(colSlider => {
  let appId = colSlider.getAttribute('id');
  createApp(CollectionSlider).mount(`#${appId}`);
});

[...document.querySelectorAll('.fs-collection-split')].forEach(colSplit => {
  let appId = colSplit.getAttribute('id');
  createApp(CollectionSplitGrid).mount(`#${appId}`);
});

function mountProductTileGroup(el) {
  if (!el || el.dataset.ptgMounted === 'true') return;
  const appId = el.getAttribute('id');
  if (!appId) return;
  el.dataset.ptgMounted = 'true';
  createApp(ProductTileGroup).mount(`#${appId}`);
}

window.mountProductTileGroup = mountProductTileGroup;

(function bootstrapProductTileGroups() {
  const groups = [...document.querySelectorAll('.product-tile-group')];
  if (!groups.length) return;

  if (typeof IntersectionObserver === 'undefined') {
    groups.forEach(mountProductTileGroup);
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          mountProductTileGroup(entry.target);
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '300px' }
  );

  groups.forEach(el => observer.observe(el));
})();

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', e => {
    [...e.target.querySelectorAll('.product-tile-group')].forEach(mountProductTileGroup);
  });
}

if (document.getElementById('product-comparison')) {
  createApp(ProductComparison).mount('#product-comparison');
}

const adaValidatorRoot = document.getElementById('ada-validator-root');
if (adaValidatorRoot) {
  createApp(AdaValidator).mount('#ada-validator-root');
}

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector('#product-comparison')) {
      createApp(ProductComparison).mount('#product-comparison');
    }
  });
}

attachCustomerAccountCookieOAuthToWindow();

console.log(`gm.js v${__GM_BUILD_VERSION__} loaded`);
